import { Badge } from '@/components/ui/Badge'
import { Skeleton } from '@/components/ui/skeleton'
import { Target, CheckCircle, AlertTriangle } from 'lucide-react'

interface ProaBannerProps {
  meta: number
  atingido: number
  passed: boolean
  isLoading?: boolean
  noData?: boolean
}

export function ProaBanner({ meta, atingido, passed, isLoading, noData }: ProaBannerProps) {
  if (isLoading) {
    return (
      <div
        className="rounded-monumenta border border-brand-gray/20 bg-brand-dark-light p-4"
        data-testid="proa-banner"
      >
        <div className="flex items-center gap-4">
          <Skeleton variant="text" className="w-48 h-5" />
          <Skeleton variant="text" className="w-48 h-5" />
        </div>
      </div>
    )
  }

  if (noData) {
    return (
      <div
        className="rounded-monumenta border border-brand-gray/20 bg-brand-dark-light p-4"
        data-testid="proa-banner"
      >
        <div className="flex items-center gap-3">
          <Target className="text-brand-gray" size={18} />
          <span className="text-sm font-body text-brand-gray">
            Sem dados PROA para o ano selecionado
          </span>
        </div>
      </div>
    )
  }

  const severityBg = passed ? 'bg-success/10' : 'bg-error/10'
  const severityBorder = passed ? 'border-success/30' : 'border-error/30'
  const severityText = passed ? 'text-success' : 'text-error'

  return (
    <div
      className={`rounded-monumenta border ${severityBorder} ${severityBg} p-4`}
      data-testid="proa-banner"
    >
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-4">
          <Target className={severityText} size={18} />
          <div className="flex items-center gap-4 text-sm font-body">
            <span className="text-brand-gray">
              Meta: <span className="text-white font-medium">{meta}%</span>
            </span>
            <span className="text-brand-gray">
              Atingido: <span className={`font-medium ${severityText}`}>{atingido}%</span>
            </span>
          </div>
        </div>
        <Badge
          variant={passed ? 'success' : 'error'}
          data-testid="proa-status-badge"
          className="inline-flex items-center gap-1.5"
        >
          {passed ? (
            <><CheckCircle className="w-3.5 h-3.5" /> Atingido</>
          ) : (
            <><AlertTriangle className="w-3.5 h-3.5" /> Abaixo da Meta</>
          )}
        </Badge>
      </div>
    </div>
  )
}
